// PostHog analytics helpers.
// PostHog is initialized in instrumentation-client.ts (Next.js 15.3+ approach).
// This module exposes a capture() wrapper for use throughout the app.

import posthog from "posthog-js";

type Props = Record<string, unknown>;

/** No-op kept for backwards compatibility — PostHog is initialized via instrumentation-client.ts. */
export function initAnalytics(): void {}

/** Capture an event. */
export function capture(event: string, props?: Props): void {
  if (typeof window === "undefined") return;
  posthog.capture(event, props);
}
